import { Component, OnInit, TemplateRef } from '@angular/core';
import { UserService, Puser, User, PatientService } from '../../shared';
import * as _ from 'lodash';
import { environment } from '../../shared/config/app-config';
import { ActivatedRoute, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Options } from '@angular-slider/ngx-slider';

@Component({
  selector: 'app-patient-assessment-details',
  templateUrl: './patient-assessment-details.component.html',
  styleUrls: ['./patient-assessment-details.component.css']
})
export class PatientAssessmentDetailsComponent implements OnInit {
  imageURL: string = environment.cloudeImageURL;
  excludeBundle: boolean = false;
  patdis: any;
  public name: any;
  resp: any;
  survey: any = [];
  menustatus: boolean = false;
  twowaymsg: boolean = false;
  chckinsurvey: boolean = false;
  menu: any;
  surveyques: any;
  intro: any;
  ques: any = [];
  answer: any = [];
  public surveydate: any = {};
  ansvalue: any;
  modalRef: BsModalRef;
  ans: any;
  apiurl = environment.api_url;
  result: any;
  number: any;
  complete = false;
  enablepage = false;
  public object: any;
  CurrentUser: User;
  PUser: Puser;
  public params: any;
  innerresult: any;
  innerques: any;
  disclaimerRequired: boolean = false
  constructor(
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private userService: UserService,
    private patientService: PatientService
  ) { }
  ngOnInit() {
    this.route.params.subscribe(params => this.name = params);
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
      }
    )

    if (this.CurrentUser.item.hostModel == "CLOUD")
      this.imageURL = environment.cloudeImageURL;
    else
      this.imageURL = environment.vmImageURL;

    this.userService
      .fetchCkChForPatDisclaimer('Assessment', this.name.name)
      .subscribe(
        data => {

          this.patdis = data.patDisclaimer;

          // ////console.log(this.patdis)
        }

      );

    this.getmenu();
    if (this.route.snapshot.url[0].path != 'assessment') {
      this.CurrentUser.operationStatus = ''
    }
    this.userService.PUser.subscribe(
      (puserData) => {
        this.resp = puserData;


      }
    )
    if (this.name.name) {
      this.userService.getExcludeBundle(window.localStorage['Puser']).subscribe(
        data => {
          this.excludeBundle = data.excludeBundle;
          // ////console.log("BundleInfo", this.excludeBundle);
          let self = this;
          this.userService
            .getviewsurvey(this.name.name)
            .subscribe(
              data => {
                self.userService.getsurvey(this.name.name, window.localStorage['Puser'], 1)
                  .subscribe(data1 => {
                    self.enablepage = true;
                    self.result = data1[1].result;
                    self.innerques = data1[0].survey.sQuestion
                    this.intro = data1[0].survey.introduction;
                    data.forEach((element, index) => {
                      if (element.active == '1' || (self.result && self.result[index] && self.result[index].resultQuestionId == element.questionId)) {
                        self.survey.push(element)
                      }
                    });

                  })
                let index = _.findIndex(this.survey, (o: any): any => {
                  return (o.disclaimerRequired)
                })
                if (index != -1) {
                  this.disclaimerRequired = true
                } else {
                  this.disclaimerRequired = false
                }
              }
            );
        });
    }
    this.getSurveyDate()
  }


  getmin(anstype) {
    if (anstype) {
      let arrval = anstype.choiceType.split(',')
      return arrval[0]
    }
  }
  getmax(anstype) {
    if (anstype) {
      let arr = anstype.choiceType.split(',')
      return arr[1]
    }
  }

  getmenu() {
    this.userService.postuserinfoid('1', this.CurrentUser.item.userAccountId)
      .subscribe(
        data => {
          this.menu = data[1].menu;

          if (this.menu) {
            for (var i = 0; i < this.menu.length; i++) {
              if (this.menu[i].refName == 'PAT_TWOWAYMESSAGE') {
                this.menustatus = this.menu[i].status

              }
              else if (this.menu[i].refName == 'DIS_PAT_TWOWAYMESSAGE') {
                this.twowaymsg = this.menu[i].status
              }
              else if (this.menu[i].refName == 'DIS_PAT_CKCH_SURVEY') {
                this.chckinsurvey = this.menu[i].status
              }
            }
          }
        })


  }
  checkans(result: any[], ansid) {
    let index = _.findIndex(result, (o: any): any => {
      return (o.choicetypeFk == ansid && o.selectAnswerType == null)
    })
    if (index != -1) {
      return true
    } else {
      return false;
    }
  }
  checkold(result: any[], ansid) {
    let index = _.findIndex(result, (o: any): any => {
      return (o.choicetypeFk == ansid && o.selectAnswerType == "OLD")
    })
    let index1 = 0;
    for (var i = 0; i < result.length; i++) {
      if (result[i].choicetypeFk == ansid && (result[i].selectAnswerType == null || result[i].selectAnswerType == undefined)) {
        index1 = -1;
        break;
      }
    }

    if (index != -1 && index1 != -1) {
      return true
    } else {
      return false;
    }
  }
  checknew(result: any[], ansid) {
    let index = _.findIndex(result, (o: any): any => {
      return (o.choicetypeFk == ansid && o.selectAnswerType == null)
    })
    let index1 = -1;
    let oldnew = -1;
    for (var i = 0; i < result.length; i++) {
      if (result[i].choicetypeFk == ansid && result[i].selectAnswerType == "OLD") {
        index1 = i;
        break;
      }
      if (result[i].selectAnswerType == "OLD") {
        oldnew = i
      }
    }

    if (index != -1 && index1 == -1 && oldnew != -1) {
      return true
    } else {
      return false;
    }
  }
  checknewtext(result: any[]) {
    let index = _.findIndex(result, (o: any): any => {
      return (o.selectAnswerType == null)
    })
    let index1 = -1;
    for (var i = 0; i < result.length; i++) {
      if (result[i].selectAnswerType == "OLD") {
        index1 = i;
        break;
      }
    }
    if (index != -1 && index1 != -1) {
      if (result[index].choiceValue != result[index1].choiceValue) {
        return true
      }
    } else {
      return false;
    }
  }

  checksold(result: any[], ansid) {
    let index1
    var answer = result[0].choiceValue.split('##');
    index1 = _.findIndex(answer, (o: any): any => {
      return o == ansid
    })
    let index = -1;
    for (var i = 0; i < result.length; i++) {
      answer = result[i].choiceValue.split('##');
      for (var j = 0; j < answer.length; j++) {
        if (answer[j] == ansid && result[i].selectAnswerType == 'OLD') {
          index = j
        }
      }
    }

    if (index1 == -1 && index != -1) {
      return true
    } else {
      return false;
    }
  }
  checknold(result: any[], ansid) {
    let index1
    var answer = result[0].choiceValue.split('##');
    index1 = _.findIndex(answer, (o: any): any => {
      return o == ansid
    })
    let index = -1;
    let old = -1
    for (var i = 0; i < result.length; i++) {
      answer = result[i].choiceValue.split('##');
      for (var j = 0; j < answer.length; j++) {
        if (answer[j] == ansid && result[i].selectAnswerType == 'OLD') {
          index = j
        }

      }
      if (result[i].selectAnswerType == 'OLD') {
        old = i
      }
    }

    if (index1 != -1 && index == -1 && old != -1) {
      return true
    } else {
      return false;
    }


  }
  checksans(result: any[], ansid) {
    let index
    var answer = result[0].choiceValue.split('##');
    index = _.findIndex(answer, (o: any): any => {
      return o == ansid
    })
    if (index != -1) {
      return true
    } else {
      return false;
    }
  }
  checknans(result: any[], ansid) {
    let index
    var answer = result[0].choiceValue.split('##');

    index = _.findIndex(answer, (o: any): any => {
      return o == ansid
    })

    if (index == -1) {
      if (result[0].choiceValue == '') {
        return false
      }
      else
        return true;
    } else {
      return false;
    }
  }
  getSurveyDate() {
    let self = this;
    self.patientService.getSurveyassigndate(self.name.name, window.localStorage['Puser'])
      .subscribe(data => {
        // ////console.log(data)
        self.surveydate = data;
      })
  }
  surveydownloadurl: any = environment.surveydownloadUrl;
  onPrint() {
    let printContents;
    let data: any = {
      preview: true,
      hspPatSurveyId: this.name.name,
      patientSwfId: window.localStorage['Puser'],
      lang: this.userService.selectedLang()
    }
    data = this.userService.encrypt(JSON.stringify(data))
    data = btoa(data)
    printContents = this.surveydownloadurl + data
    window.open(printContents, '_blank', 'top=0,left=0,height=100%,width=auto');
  }
  getnullvalue(value) {
    if (value) {
      if (value.toLowerCase() == 'null') {
        return ''
      } else {
        return value
      }
    } else {
      return ''
    }
  }
  textques: any;
  getinnerques(result, ques, index) {
    let self = this
    if (index) {
      let index1 = _.findIndex(self.innerques[index].sAnswer, (o: any): any => {
        return o.ansChoicetypeId == ques.resultDetailList[0].choicetypeFk
      })
      if (index1 != -1) {
        let index2 = _.findIndex(self.innerques[index].sAnswer[index1].innerChoice, (o: any): any => {
          return o.innerChoicePk == result.innerChoicePk
        })
        if (index2 != -1) {
          if (result.innerQuestionType == 'textbox' && self.innerques[index].sAnswer[index1].innerChoice[index2].innerAnsChNameArray.length == 1)
            return self.innerques[index].sAnswer[index1].innerChoice[index2].innerAnsChNameArray[0].innerAnsChName
          else if (result.innerQuestionType == 'textbox' && self.innerques[index].sAnswer[index1].innerChoice[index2].innerAnsChNameArray.length > 1) {
            self.textques = self.innerques[index].sAnswer[index1].innerChoice[index2].innerAnsChNameArray
            return 'multi'
          }
          else
            return self.innerques[index].sAnswer[index1].innerChoice[index2].innerQuestionName
        }
      }
    }
    return ''
  }
  getinnerans(result, ques, index) {
    let self = this
    if (index) {
      let index1 = _.findIndex(self.innerques[index].sAnswer, (o: any): any => {
        return o.ansChoicetypeId == ques.resultDetailList[0].choicetypeFk
      })
      if (index1 != -1) {
        let index2 = _.findIndex(self.innerques[index].sAnswer[index1].innerChoice, (o: any): any => {
          return o.innerChoicePk == result.innerChoicePk
        })
        if (index2 != -1) {
          let innerques = self.innerques[index].sAnswer[index1].innerChoice[index2].innerAnsChNameArray[0].innerAnsChName
          if (result.innerQuestionType == 'textbox')
            // return result.innerAnswerValue[innerques]    //Due to Backend convert the getSurvey ResultJson for language compatiblity
            return result.innerAnswerValue
          else
            return result.innerAnswerValue
        }
      }
    }
    return ''
  }
  getinnnerchoice(result, ques, index) {
    let self = this
    let index1 = _.findIndex(self.innerques[index].sAnswer, (o: any): any => {
      return o.ansChoicetypeId == ques.resultDetailList[0].choicetypeFk
    })
    if (index1 != -1) {
      let index2 = _.findIndex(self.innerques[index].sAnswer[index1].innerChoice, (o: any): any => {
        return o.innerChoicePk == result.innerChoicePk
      })
      if (index2 != -1)
        return self.innerques[index].sAnswer[index1].innerChoice[index2].innerAnsChNameArray
    }
  }

  getName(name) {
    if (name) {
      let title = name.toLowerCase()
      if (title.search('pain') != -1) {
        return true
      } else
        return false
    } else {
      return false
    }
  }

  sliderOption(anstype) {
    let options: Options = {
      floor: 0,
      ceil: this.getmax(anstype),
      step: 1,
      minRange: this.getmin(anstype),
      maxRange: this.getmax(anstype),
      showTicks: true,
      getLegend: (value: number): any => {
        return value;
      }
    };
    return options
  }

}
